// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__2qOmM"};